import * as React from "react";
import { useState } from 'react';
import { useDataProvider, useNotify, useRefresh, Button } from 'react-admin';

export const UnpublishButton = ({ record }) => {
    const notify = useNotify();
    const dataProvider = useDataProvider();
    const myrefresh = useRefresh();
    const [loading, setLoading] = useState(false);
    if (!record) return null;
    if (record.status !== "active") {
      return <Button label="Unpublish" disabled={true} />;
    }
    const unpublish = () => {
      setLoading(true);
      dataProvider
        .unpublish('job_offers', { id: record.id })
        .then(response => {
            setLoading(false);
            myrefresh();
            notify('Offer unpublished');
        })
        .catch(error => {
            setLoading(false);
            notify('Something went wrong!');
        });
      }
    return <Button label="Unpublish" onClick={unpublish} disabled={loading} />;
};
